import React, { useState, useEffect } from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
import history from "../../routes/history";
import CandidateSignupButton from "../../pages/PostAJob/EmployerProfile/components/CandidateBackNext/CandidateSignupButton";
import { Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { candidateDetailSuccess } from '../../redux/actions';
import "./gigtypes.css";
import errorIcon from "../../assets/img/ci_warning.png";

const GigType = () => {
  const [showError, setShowError] = useState(false);
  const dispatch = useDispatch();
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const professionCode = userProfile?.Professions?.ProfessionCode;
  const getInputValues = useSelector((state) => state.candidateReducer.candidateDetails);
  const [checkValue, setCheckValue] = useState(getInputValues?.gigType || "");

  const backFunction = () => {
    history.push("/candidate-number");
  };

  const nextFunction = () => {
    if (checkValue) {
      dispatch(candidateDetailSuccess({ ...getInputValues, gigType: checkValue }));
      history.push("/gig-title");
    } else {
      setShowError(true);
    }
  };

  const skipFunction = () => {
    history.push("/gig-title");
  };

  const handleRadioClick = (value) => {
    setShowError(false); 
    setCheckValue(value);
  };

  useEffect(() => {
    if (getInputValues?.gigType) {
      setCheckValue(getInputValues.gigType);
    }
  }, [getInputValues]);

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar heading={"Create candidate’s skill listing"} percent={40}/>
        <div className="email-text">
          Select Gig type
          <div className="email-mandatory">(Optional)</div>
        </div>
        <div className="gig-sub">
        {professionCode === "IT" ? 
  "Is this candidate being considered for a contract or permanent position?" 
  : "Is this candidate being considered for a Contract, Permanent or per diem position?"
}
 </div>
        <div className="mobilemain">
          <div className="mobilesubs"></div>
          <div>
            <Radio.Group
              className="create-skl-lst-card-cnt"
              onChange={(e) => handleRadioClick(e.target.value)}
              value={checkValue}
            >
              {professionCode === "HC" ? (
                <>
                  <div
                    className="skillcreate-name-radio-btn"
                    onClick={() => handleRadioClick("Contract")}
                  >
                    <Radio value="Contract">Contract</Radio>
                  </div>
                  <div
                    className="skillcreate-name-radio-btn"
                    onClick={() => handleRadioClick("Permanent")}
                  >
                    <Radio value="Permanent">Permanent</Radio>
                  </div>
                  <div
                    className="skillcreate-name-radio-btn"
                    onClick={() => handleRadioClick("PerDiem")}
                  >
                    <Radio value="PerDiem">Per diem</Radio>
                  </div>
                </>
              ) : professionCode === "IT" ? (
                <>
                  <div
                    className="skillcreate-name-radio-btn"
                    onClick={() => handleRadioClick("Contract")}
                  >
                    <Radio value="Contract">Contract</Radio>
                  </div>
                  <div
                    className="skillcreate-name-radio-btn"
                    onClick={() => handleRadioClick("Permanent")}
                  >
                    <Radio value="Permanent">Permanent</Radio>
                  </div>
                </>
              ) : null}
            </Radio.Group>
          </div>
        </div>
        {showError && (
          <div className="error-msg-content">
            <img src={errorIcon} alt="Error" />
            <span className="error-text">
              Please select the gig type to continue
            </span>
          </div>
        )}
        <div style={{ paddingTop: "10%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            skipFunction={skipFunction}
          />
        </div>
      </div>
    </div>
  );
};

export default GigType;
